/**
 * @fileoverview File contains all the logic for the custom bundles. Utilizes
 * `custom-bundles-utils.js` and `utils.js` for helper functions.
 */

$(document).ready(function () {
	var customBundleRequirements = {};
	var selectedItems = {}; // Items selected by the user to be added to cart.
	var totalItemRequirement = 0;
	var selectedBundleDiscount =
		Number($(".custom-bundle-info").attr("data-bundle-discount")) || 0;

	$(".bundle-requirements").each(function () {
		var selectionAreaId = $(this).attr("data-selection-area-id");
		var selectionAreaRequirement = Number($(this).attr("data-required-value"));
		customBundleRequirements[selectionAreaId] = selectionAreaRequirement;
		totalItemRequirement += selectionAreaRequirement;
		selectedItems[selectionAreaId] = {};
	});

	var selectionAreaOrder = Object.keys(customBundleRequirements);
	var currentSelectionArea = 0; // Tracks which selection area to show next.

	$(document).on("click", ".custom-bundle-button", function (e) {
		var selectedProductId = $(this).attr("data-product-id");
		var selectedProductSku = $(this).attr("data-product-sku");
		var selectedProductHandle = $(this).attr("data-product-handle");
		var selectedProductPrice = $(this).attr("data-product-price");
		var selectedProductImage = $(this).attr("data-product-image");
		var selectedSelectionAreaId = $(this).attr("data-selection-area-id");
		var selectedSelectionAreaRequirement =
			customBundleRequirements[selectedSelectionAreaId];
		var selectedSelectionAreaTotal = Object.keys(
			selectedItems[selectedSelectionAreaId]
		).length;

		if (
			$(this).text().trim().toLowerCase() == "add" &&
			selectedSelectionAreaRequirement > selectedSelectionAreaTotal
		) {
			selectedItems[selectedSelectionAreaId][selectedProductHandle] = {};
			selectedItems[selectedSelectionAreaId][selectedProductHandle].productId =
				Number(selectedProductId);
			selectedItems[selectedSelectionAreaId][selectedProductHandle].productSku =
				selectedProductSku;
			selectedItems[selectedSelectionAreaId][
				selectedProductHandle
			].productPrice = selectedProductPrice;
			selectedItems[selectedSelectionAreaId][
				selectedProductHandle
			].productImage = selectedProductImage;

			// Updates total amount of current selected items custom bundle kit bar.
			$(".custom-bundle-price.Price--highlight").text(
				formatPriceWithCurrencySymbol(totalPriceChecker(selectedItems))
			);

			// Iterate each available 'bundle-item' container and fills it with image
			// of selected item.
			$(".bundle-item-container").each(function () {
				var bundleItem = $(this).children(".bundle-item");
				var bundleRemoveIcon = $(this).children(".remove-icon-container");
				var bundleItemEmpty = bundleItem.attr("data-empty");

				if (bundleItemEmpty == "true") {
					bundleItem.attr({
						"data-empty": "false",
						src: selectedProductImage,
					});

					bundleRemoveIcon.attr({
						"data-product-id": selectedProductId,
						"data-product-handle": selectedProductHandle,
						"data-selection-area-id": selectedSelectionAreaId,
					});

					bundleItem.removeClass("bundle-item-hidden");
					bundleRemoveIcon.removeClass("remove-icon-hidden");
					return false; // Once filled, break to fill just one container.
				}
			});

			$(this).toggleClass("Button--primary Button--secondary");
			$(this).text("remove");

			// Double checks if updated length is required count.
			if (
				Object.keys(selectedItems[selectedSelectionAreaId]).length ==
				selectedSelectionAreaRequirement
			) {
				// Locks all the buttons available to be clicked.
				changeSelectionAreaState(selectedSelectionAreaId, false);

				// Displays next selection area.
				currentSelectionArea += 1;
				$(
					".selection-area-" + selectionAreaOrder[currentSelectionArea]
				).removeClass("selection-area-hidden");

				var selectedItemsTotal = 0;
				for (var sectionItems in selectedItems) {
					selectedItemsTotal += Object.keys(selectedItems[sectionItems]).length;
				}

				if (selectedItemsTotal == totalItemRequirement) {
					$(".custom-bundle-form").removeClass(
						"Button--secondary custom-bundle-form-disabled"
					);
					$(".custom-bundle-form").addClass("Button--primary");

					var originalBundlePrice = totalPriceChecker(selectedItems);
					if (selectedBundleDiscount > 0) {
						// Show final discounted price of custom bundle.
						$(".custom-bundle-price.Price--compareAt").addClass("visible");

						var discountedBundlePrice = totalPriceChecker(selectedItems, true);
						$(".custom-bundle-price.Price--highlight").text(
							formatPriceWithCurrencySymbol(discountedBundlePrice)
						);
						$(".custom-bundle-price.Price--compareAt").text(
							formatPriceWithCurrencySymbol(originalBundlePrice)
						);
					} else {
						$(".custom-bundle-price.Price--compareAt").removeClass("visible");
						$(".custom-bundle-price.Price--compareAt").text("");
						$(".custom-bundle-price.Price--highlight").text(
							formatPriceWithCurrencySymbol(originalBundlePrice)
						);
					}

					// Only open kit (mobile) if closed.
					if (
						$(".custom-bundle-mobile").text().trim().toLowerCase() == "view kit"
					) {
						$(".toggle-custom-bundle").click();
					}
				}

				// Error handling in case users go back and changes their selected items.
				if (selectionAreaOrder[currentSelectionArea] == undefined) return;

				$(
					".selection-area-" + selectionAreaOrder[currentSelectionArea]
				)[0].scrollIntoView({
					behavior: "smooth",
					block: "start",
				});
			}
		} else {
			removeSelectedItem(
				selectedProductId,
				selectedProductHandle,
				selectedSelectionAreaId,
				selectedSelectionAreaTotal,
				selectedSelectionAreaRequirement,
				selectedItems,
				this
			);
		}
	});

	// Removes selected item using the 'remove icon' on kit bar.
	$(document).on("click", ".remove-icon-container", function (e) {
		var selectedProductId = $(this).attr("data-product-id");
		var selectedProductHandle = $(this).attr("data-product-handle");
		var selectedSelectionAreaId = $(this).attr("data-selection-area-id");
		var selectedSelectionAreaRequirement =
			customBundleRequirements[selectedSelectionAreaId];
		var selectedSelectionAreaTotal = Object.keys(
			selectedItems[selectedSelectionAreaId]
		).length;

		$(this).addClass("remove-icon-hidden");

		// Releases item that was removed from selected items.
		$(".custom-bundle-button").each(function (e) {
			if (
				selectedProductId == $(this).attr("data-product-id") &&
				selectedSelectionAreaId == $(this).attr("data-selection-area-id")
			) {
				removeSelectedItem(
					selectedProductId,
					selectedProductHandle,
					selectedSelectionAreaId,
					selectedSelectionAreaTotal,
					selectedSelectionAreaRequirement,
					selectedItems,
					this
				);
			}
		});
	});

	// Prevents form from submitting when product quantity is changed through
	// input attr in cart(drawer and cart page).
	$(document).on("keydown", ".Cart", function (e) {
		var keyCode = e.keyCode;
		$(document).on("submit", ".Cart", function (e) {
			const enterOrReturnKeyCode = 13;
			if (keyCode == enterOrReturnKeyCode) {
				e.preventDefault();
			}
		});
	});

	// Opens or closes kit on mobile view.
	$(".toggle-custom-bundle").click(function () {
		$(".selected-bundle-main").toggleClass("selected-bundle-main-hidden");
		$(".selected-bundle-header").toggleClass("kit-open kit-close");
		$(".kit-arrow").toggleClass("kit-arrow-down kit-arrow-up");
		$(".custom-bundle-mobile").toggleClass("Button--primary Button--secondary");

		if ($(".custom-bundle-mobile").text().trim().toLowerCase() == "view kit") {
			$(".custom-bundle-mobile").text("close kit");
		} else {
			$(".custom-bundle-mobile").text("view kit");
		}
	});

	// Adds all selected items in bundle in cart.
	$(".custom-bundle-form").click(function () {
		// Get all selected items by the user.
		var selectedLineItems = convertToLineItem(selectedItems);

		// Get all the pre-selected items predetermined with the custom bundle.
		var preSelectedLineItems = [];
		$(".bundle-item.preselected-item").each(function (e) {
			preSelectedLineItems.push({
				id: Number($(this).attr("product-id")),
				quantity: 1,
			});
		});

		// Combine pre-selected and selected items to be added to cart.
		var bundleLineItems = [...preSelectedLineItems, ...selectedLineItems];

		// Create unque id for the bundle.
		var bundleLineItemIds = [];
		for (var lineItem of bundleLineItems) {
			bundleLineItemIds.push(lineItem.id);
		}

		// Create a unique id for the bundle.
		var bundleId = bundleIdBuilder(bundleLineItemIds);
		bundleLineItems.forEach(function (lineItem, idx) {
			lineItem.properties = {};
			lineItem.properties["_custom_bundle_id"] = bundleId;
			lineItem.properties["_bundle_discount"] = $(".custom-bundle-info").attr(
				"data-bundle-discount"
			);
			lineItem.properties["_bundle_alias"] = $(".custom-bundle-info").attr(
				"data-bundle-alias"
			);
			lineItem.properties["_bundle_ref_handle"] = $(".custom-bundle-info").attr(
				"data-bundle-title"
			);

			// Add custom bundle title to each product to be referenced. Implemented
			// for there are duplicate products in products within the bundle. When
			// there are duplicate products selected in the bundle, they are both
			// combined in cart and have a quantity of 2, instead of having to
			// seperate them.
			lineItem.properties[
				"_" + $(".custom-bundle-info").attr("data-bundle-title")
			] = idx + 1;
		});

		// Makes sure that list of items in the bundle referencer are in order.
		bundleLineItems.reverse();

		// Add 'dummy bundle' or the bundle reference to the cart and display
		// bundle items that is included using line item properties.
		var customBundleReference = {};

		$(".bundle-item.preselected-item").each(function () {
			var selectedProduct = $(this).attr("product-title");

			// Remove default title on selected product handle.
			var cleanSelectedProductTitle = selectedProduct.replaceAll(
				"-Default Title",
				""
			);
			customBundleReference["_- " + cleanSelectedProductTitle] =
				$(this).attr("product-sku") || "NOSKU";
		});

		for (var selectionArea in selectedItems) {
			// Get each product title.
			Object.keys(selectedItems[selectionArea]).forEach((selectedProduct) => {
				// Remove default title on selected product handle.
				var cleanSelectedProductTitle = selectedProduct.replaceAll(
					"-Default Title",
					""
				);
				customBundleReference["_- " + cleanSelectedProductTitle] =
					selectedItems[selectionArea][selectedProduct].productSku || "NOSKU";
			});
		}

		customBundleReference["_bundle_reference"] = bundleId;

		// Add bundle referencer.
		bundleLineItems.push({
			id: Number($(".custom-bundle-info").attr("data-custom-bundle-reference")),
			quantity: 1,
			properties: customBundleReference,
		});

		(async () => {
			await addToCartAjax(bundleLineItems, this);
			// NOTE: The code below was being user to show the optional items modal after a customer purchases a custom bundle.
			$(".selected-bundle-container").addClass("tw-hidden");
			$(".custom-bundle-main").addClass("tw-hidden");
			// scroll to top of page
			$(document).scrollTop(0);
			$("#optional-items-modal").removeClass("tw-hidden");
			let remainingTime = 180; // seconds

			// superficial countdown timer on bonus items modal
			const countdownEl = document.getElementById("modal-countdown");
			if (countdownEl) {
				const countdownInterval = setInterval(() => {
					remainingTime--;
					const minutes = Math.floor(remainingTime / 60);
					const seconds = remainingTime % 60;
					// Update timer with urgency message
					countdownEl.textContent =
						"Act now! " +
						`${minutes}:${seconds < 10 ? "0" + seconds : seconds}`;
					if (remainingTime <= 0) {
						clearInterval(countdownInterval);
						modal.classList.add("tw-hidden");
					}
				}, 1000);
			}
		})();
	});

	// Only show kit bar when custom bundle selection area is within viewport.
	if ($(".custom-bundle-main").length) {
		var customBundlePosition = $(
			".custom-bundle-main"
		)[0].getBoundingClientRect();
		const footerEl = $(".Footer");
		const selectedBundleContainer = $(".selected-bundle-container");

		$(window).scroll(function () {
			if (
				$(window).scrollTop() + $(window).height() >
				customBundlePosition.top
			) {
				selectedBundleContainer.removeClass("selected-bundle-container-hidden");
				const selectedBundleContainerHeight =
					selectedBundleContainer.outerHeight();
				footerEl.css(
					"padding-bottom",
					selectedBundleContainerHeight + 25 + "px"
				);
			} else {
				selectedBundleContainer.addClass("selected-bundle-container-hidden");
				footerEl.css("padding-bottom", "initial");
			}
		});

		// Initially sets the price of the bundle to only preselected items.
		$(".custom-bundle-price.Price--highlight").text(
			formatPriceWithCurrencySymbol(preSelectedItemChecker())
		);
	}

	// Adds rendered products using any product-item snippet.
	$(document).on("click", ".Product-Item", function (e) {
		e.preventDefault();

		// Check for products with variants.
		if ($(this).attr("data-action") == "variant-add-to-cart") {
			$('.CollectionPopover[aria-hidden="false"]').attr("aria-hidden", true);
			$(".availableVariants.ActiveButton").removeClass("ActiveButton");
		}

		var productInfo = {
			id: $(this).attr("data-id"),
			quantity: 1,
			properties: {},
		};

		var dataKey = $(this).attr("data-key");
		if (dataKey) {
			productInfo.properties[decodeBase64("X2luX2NhcnRfZGlzY291bnQ")] = Number(
				decodeBase64(dataKey)
			);
		}

		addToCartAjax([productInfo], this);
	});
});
